import {MI} from "../init";
import MadnesTween from "../libs/mi/MadnesTween";

/**
 * @constructor
 * @param {MadnesObject} object
 */
export default function ShuffleAnim(object) {

    /** @type {MadnesObject} */
    this.object = object;
    /** @type {MadnesTween} */
    this.anim;

    /** @type {Function} */
    this._onOut;
};

/**
 * @param {Object<string, Array>} path
 * @param {number=} delay
 * @param {number=} inDuration
 * @param {number=} duration
 * @param {number=} outDuration
 * @returns {Promise}
 */
ShuffleAnim.prototype.run = function(path, delay, inDuration, duration, outDuration) {

    return new Promise(function(res) {

        delay = delay ? delay : 0;
        inDuration = inDuration ? inDuration : 1000;
        duration = duration ? duration : 1000;
        outDuration = outDuration ? outDuration : 600;

        var firstPosX = path['x'].shift();
        var firstPosY = path['y'].shift();
        var lastPosX = path['x'].pop();
        var lastPosY = path['y'].pop();

        this.anim = MI.addTween().to(this.object, { 'x': firstPosX, 'y': firstPosY }, {
            'duration': inDuration,
            'delay': delay,
            'easing': MadnesTween.getEasing("sinusoidal_in"),
            'callback': function() {
                this.anim.to(this.object, { 'x': path['x'], 'y': path['y'] }, {
                    'duration': duration,
                    'callback': function() {

                        this._onOut && this._onOut();

                        this.anim.to(this.object, { 'x': lastPosX, 'y': lastPosY }, {
                            'duration': outDuration,
                            'easing': MadnesTween.getEasing("sinusoidal_out"),
                            'callback': res
                        });
                    }.bind(this)
                }).catmull();
            }.bind(this)
        });
    }.bind(this));
};

ShuffleAnim.prototype.setOnOut = function(func) {
    this._onOut = func;
};

ShuffleAnim.prototype.stop = function() {
    this.anim.stop();
};